// @ts-check
import React from 'react';

/**
 * Accepts a function that maps owner props to a new collection of props that are passed to the base component.
 */
export const mapProps = (propsMapper) => (BaseComponent) => {
  const MapProps = (props) => <BaseComponent {...propsMapper(props)} />;

  return MapProps;
};

export default mapProps;
